import { ActionButton } from "@/components/action/action-button";
import { Layers, Plus } from "lucide-react";

interface EmptyVariantsStateProps {
  onAddVariant: () => void;
}

export function EmptyVariantsState({ onAddVariant }: EmptyVariantsStateProps) {
  return (
    <div className="text-center py-12">
      <Layers className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
      <h3 className="text-lg font-semibold">No variants yet</h3>
      <p className="text-muted-foreground mb-4">
        Create variants to offer different options for this product.
      </p>
      <ActionButton onClick={onAddVariant}>
        <Plus className="h-4 w-4 mr-2" />
        Add Variant
      </ActionButton>
    </div>
  );
}
